// extracted by mini-css-extract-plugin
export default {"container":"JD-z","innerContainer":"KD-z","multipleLines":"LD-z","heading":"MD-z","content":"ND-z","linkColor":"OD-z"};